import { setupExternal } from './external'
import { setupGoogleMaps } from './googleMaps'

export function setupPlugins(app, store) {
  setupExternal(app)
  setupGoogleMaps(app, store)
}
